import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Tag, TrendingUp } from 'lucide-react';
export function Consignacion() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    auto: '',
    anio: '',
    km: 'Menos de 50.000 km',
    opcion: 'Venta en consignación',
    seguro: 'Sí'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola Flash & Go! Quiero dejar mi auto en consignación. Mis datos:
*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Auto:* ${formData.auto}
*Año:* ${formData.anio}
*Kilometraje:* ${formData.km}
*Opción:* ${formData.opcion}
*Seguro vigente:* ${formData.seguro}`;
    window.open(`https://wa.me/5491127063704?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <section id="consignacion" className="py-32 bg-brand-black relative" data-id="element-173" data-mp="2u8yqkgda2645">
      <div className="max-w-7xl mx-auto px-6" data-id="element-174" data-mp="2ya0psx772i64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-175" data-mp="2yasmycgfwnyi">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-176" data-mp="10qrlf2cssm44">
            Dejanos tu auto, nosotros lo{' '}
            <span className="text-brand-gold" data-id="element-177" data-mp="1tf5k7kbpnmgq">hacemos rendir</span>
          </h2>
          <p className="text-xl text-brand-white/80" data-id="element-178" data-mp="1tct2n89v7e47">
            Dos opciones para que tu auto trabaje por vos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-179" data-mp="1jg6fudxzaczj">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl" data-id="element-180" data-mp="1eiegwzyx1qlu">
            <Tag className="w-12 h-12 text-brand-gold mb-6" data-id="element-181" data-mp="2r9g5ia76jpur" />
            <h3 className="font-heading text-4xl text-brand-white mb-4" data-id="element-182" data-mp="2vajkkuhelhux">
              Lo vendemos por vos
            </h3>
            <p className="text-brand-white/70 mb-8 text-lg" data-id="element-183" data-mp="2h9z25zfeho1y">
              Dejás tu auto con nosotros y nos encargamos de toda la gestión de
              venta. Vos no movés un dedo.
            </p>
            <ul className="space-y-3" data-id="element-184" data-mp="27j4in2tjh2k7">
              {['✓ Sin comisión anticipada', '✓ Publicación en todos los portales', '✓ Atención al comprador a cargo nuestro'].map((item, i) => <li key={i} className="text-brand-gold font-medium" data-id="element-185" data-mp="23iu95g6jfu0l" data-mpi={i}>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl" data-id="element-186" data-mp="1tkmw38fddw3v">
            <TrendingUp className="w-12 h-12 text-brand-gold mb-6" data-id="element-187" data-mp="1jyvfjldych01" />
            <h3 className="font-heading text-4xl text-brand-white mb-4" data-id="element-188" data-mp="1exxxd8sxzmyj">
              Lo ponemos a trabajar
            </h3>
            <p className="text-brand-white/70 mb-6 text-lg" data-id="element-189" data-mp="1swfhyxnjwjc8">
              Dejamos tu auto operando en plataformas de movilidad y te
              generamos una rentabilidad mensual.
            </p>
            <div className="bg-brand-gold/10 border border-brand-gold p-4 rounded-lg mb-6 text-center" data-id="element-190" data-mp="22na6k8o9rv0u">
              <span className="text-brand-gold font-bold text-xl" data-id="element-191" data-mp="1xp8l5h3dfjm7">
                Entre $800.000 y $1.200.000 por mes
              </span>
            </div>
            <ul className="space-y-3" data-id="element-192" data-mp="27nemnxl9mnqj">
              {['✓ Nosotros gestionamos todo', '✓ Pagos mensuales garantizados', '✓ Tu auto siempre asegurado'].map((item, i) => <li key={i} className="text-brand-gold font-medium" data-id="element-193" data-mp="9xq0gahh5107" data-mpi={i}>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative overflow-hidden" data-id="element-194" data-mp="joc9fluoqt9x">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-195" data-mp="yw5eojskior"></div>
          <h3 className="font-heading text-3xl text-brand-gold mb-6 text-center" data-id="element-196" data-mp="17eyed49e7xfp">
            Quiero dejar mi auto en consignación
          </h3>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-197" data-mp="1cc83sjws893j">
            <div className="grid md:grid-cols-2 gap-4" data-id="element-198" data-mp="2ww3gpzwrpe21">
              <div data-id="element-199" data-mp="2wxwrnreeykfu">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-200" data-mp="2rwz7xadr9ic8">
                  Nombre completo
                </label>
                <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                nombre: e.target.value
              })} data-id="element-201" data-mp="2n4z2x3itvz8s" />
              </div>
              <div data-id="element-202" data-mp="1z8bkb85jagvi">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-203" data-mp="1z93eqfnea8k7">
                  Teléfono
                </label>
                <input required type="tel" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                telefono: e.target.value
              })} data-id="element-204" data-mp="2f9r6zdf8tkb" />
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4" data-id="element-205" data-mp="1myc2ttx7w182">
              <div className="md:col-span-2" data-id="element-206" data-mp="2anoceuwgibaw">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-207" data-mp="2any0ue1usaeh">
                  Marca y modelo del auto
                </label>
                <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                auto: e.target.value
              })} data-id="element-208" data-mp="20p8r58k41w9b" />
              </div>
              <div data-id="element-209" data-mp="38j0nywhij7r8">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-210" data-mp="33hthd0r3wem5">
                  Año
                </label>
                <input required type="number" min="1990" max="2026" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                anio: e.target.value
              })} data-id="element-211" data-mp="3hi469y8uvj4o" />
              </div>
            </div>

            <div data-id="element-212" data-mp="2tqqgo023a1ne">
              <label className="block text-sm text-brand-white/70 mb-1" data-id="element-213" data-mp="2tq6ug75eor3k">
                Kilometraje aproximado
              </label>
              <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
              ...formData,
              km: e.target.value
            })} data-id="element-214" data-mp="221naufuk0j8n">
                <option data-id="element-215" data-mp="34ve4kwaekkux">Menos de 50.000 km</option>
                <option data-id="element-216" data-mp="34wz2mvvxelxj">50.000 a 100.000 km</option>
                <option data-id="element-217" data-mp="39uqs7j93lvyk">100.000 a 150.000 km</option>
                <option data-id="element-218" data-mp="39tz752d4ngmj">Más de 150.000 km</option>
              </select>
            </div>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-219" data-mp="3esaft9rorl36">
              <div data-id="element-220" data-mp="3jkk6wt4jer71">
                <label className="block text-sm text-brand-white/70 mb-2" data-id="element-221" data-mp="3jk22h97q16o1">
                  ¿Qué opción te interesa?
                </label>
                <div className="flex flex-col gap-2" data-id="element-222" data-mp="3nnzyvc5nw3de">
                  {['Venta en consignación', 'Renta mensual'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-223" data-mp="1efhedbo0gc8">
                      <input type="radio" name="opcion" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                    ...formData,
                    opcion: e.target.value
                  })} defaultChecked={opt === 'Venta en consignación'} data-id="element-224" data-mp="bgj9gcwpgsv2" />
                      {opt}
                    </label>)}
                </div>
              </div>
              <div data-id="element-225" data-mp="gi8m1wzktel9">
                <label className="block text-sm text-brand-white/70 mb-2" data-id="element-226" data-mp="ggnrw8h6bxnx">
                  ¿El auto tiene seguro vigente?
                </label>
                <div className="flex gap-4" data-id="element-227" data-mp="1d1fz81kah71m">
                  {['Sí', 'No'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-228" data-mp="1871xziiy45p1">
                      <input type="radio" name="seguro" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                    ...formData,
                    seguro: e.target.value
                  })} defaultChecked={opt === 'Sí'} data-id="element-229" data-mp="2rdpty090pgxx" />
                      {opt}
                    </label>)}
                </div>
              </div>
            </div>

            <button type="submit" className="w-full mt-6 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-230" data-mp="1v79kx50uis3">
              QUIERO CONSIGNAR MI AUTO
            </button>
          </form>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-231" data-mp="lhiv9xx2xmjf"></div>
    </section>;
}